// Automatically generated
export const BREADCRUMB_LINK_KEYS = ["isCurrent"] as const;
export const BREADCRUMBS_KEYS = [] as const;
